






























import { Component, Vue } from 'vue-property-decorator';
import { getRole } from '@/utils/cookie';
import { UserRole } from '@/resource/user/user.model';
import MainButton from '@/main-components/common/MainButton.vue';
import EditorMain from '@/components/question-editor/new-editor/EditorMain.vue';

@Component({
  components: { MainButton, EditorMain },
})
export default class Dashboard2 extends Vue {
  get userRole(): UserRole | null {
    return getRole();
  }

  showQuestionEditor = false;
  isSubjectiveEditor = false;

  openObjectiveEditor() {
    this.showQuestionEditor = true;
    this.isSubjectiveEditor = false;
  }

  openSubjectiveEditor() {
    this.showQuestionEditor = true;
    this.isSubjectiveEditor = true;
  }

  closeQuestionEditor() {
    this.showQuestionEditor = false;
  }
}
